import iesadPrice from "./pricelist"; 

const iesadGroupCat = {
    "Ballet":{
        "Solo":{
            1:{
                "id":1,"number":"BLS1","name":"Primary","des":"Age 7 or below, any set piece under 3 minutes", "price":iesadPrice["BLS1"]
            },
            2:{
                "id":2,"number":"BLS2","name":"Junior","des":"Age 8-10 , any set piece under 3 minutes", "price":iesadPrice["BLS2"]
            },
            3:{
                "id":3,"number":"BLS3","name":"Intermediate","des":"Age 11-14, any set piece under 5 minutes", "price":iesadPrice["BLS3"]
            },
            4:{
                "id":4,"number":"BLS4","name":"Youth","des":"Age 15-18, any set piece under 6 minutes", "price":iesadPrice["BLS4"]
            },
            5:{
                "id":5,"number":"BLS5","name":"Adult","des":"Age 18 or above, any set piece under 8 minutes", "price":iesadPrice["BLS5"]
            },
            // 6:{
            //     "id":6,"number":"DS6","name":"Adults","des":"Age 18 or above, any theatre scene, under 6 minutes", "price":iesadPrice["DS6"]
            // },
        },
        "Duo and Trio":{
            1:{
                "id":1,"number":"BLD1","name":"Primary","des":"Age 7 or below, any set piece under 3 minutes", "price":iesadPrice["BLD1"]
            },
            2:{
                "id":2,"number":"BLD2","name":"Junior","des":"Age 8-10 , any set piece under 3 minutes", "price":iesadPrice["BLD2"]
            },
            3:{
                "id":3,"number":"BLD3","name":"Intermediate","des":"Age 11-14, any set piece under 5 minutes", "price":iesadPrice["BLD3"]
            },
            4:{
                "id":4,"number":"BLD4","name":"Youth","des":"Age 15-18, any set piece under 6 minutes", "price":iesadPrice["BLD4"]
            },
            5:{
                "id":5,"number":"BLD5","name":"Adult","des":"Age 18 or above, any set piece under 8 minutes", "price":iesadPrice["BLD5"]
            },
            // 6:{
            //     "id":6,"number":"DD6","name":"Adults","des":"Age 18 or above, any theatre scene, under 6 minutes", "price":iesadPrice["DD6"]
            // },
        },
        "Group":{
            1:{
                "id":1,"number":"BLG1","name":"Primary","des":"Age 7 or below, any set piece under 3 minutes", "price":iesadPrice["BLG1"]
            },
            2:{
                "id":2,"number":"BLG2","name":"Junior","des":"Age 8-10 , any set piece under 3 minutes", "price":iesadPrice["BLG2"]
            },
            3:{
                "id":3,"number":"BLG3","name":"Intermediate","des":"Age 11-14, any set piece under 5 minutes", "price":iesadPrice["BLG3"]
            },
            4:{
                "id":4,"number":"BLG4","name":"Youth","des":"Age 15-18, any set piece under 6 minutes", "price":iesadPrice["BLG4"]
            },
            5:{
                "id":5,"number":"BLG5","name":"Adult","des":"Age 18 or above, any set piece under 8 minutes", "price":iesadPrice["BLG5"]
            },
            // 6:{
            //     "id":6,"number":"DG6","name":"Adults","des":"Age 18 or above, any theatre scene, under 6 minutes", "price":iesadPrice["DG6"]
            // },
        },
    },
    "Jazz":{
        "Solo":{
            1:{
                "id":1,"number":"JZS1","name":"Primary","des":"Age 7 or below, any set performance under 3 minutes", "price":iesadPrice["JZS1"]
            },
            2:{
                "id":2,"number":"JZS2","name":"Junior","des":"Age 8-10 , any set performance under 3 minutes", "price":iesadPrice["JZS2"]
            },
            3:{
                "id":3,"number":"JZS3","name":"Intermediate","des":"Age 11-14, any set performance under 5 minutes", "price":iesadPrice["JZS3"]
            },
            4:{
                "id":4,"number":"JZS4","name":"Youth","des":"Age 15-18, any set performance under 6 minutes", "price":iesadPrice["JZS4"]
            },
            5:{
                "id":5,"number":"JZS5","name":"Adult","des":"Age 18 or above, any set performance under 8 minutes", "price":iesadPrice["JZS5"]
            },
            // 6:{
            //     "id":6,"number":"DS6","name":"Adults","des":"Age 18 or above, any theatre scene, under 6 minutes", "price":iesadPrice["DS6"]
            // },
        },
        "Duo and Trio":{
            1:{
                "id":1,"number":"JZD1","name":"Primary","des":"Age 7 or below, any set performance under 3 minutes", "price":iesadPrice["JZD1"]
            },
            2:{
                "id":2,"number":"JZD2","name":"Junior","des":"Age 8-10 , any set performance under 3 minutes", "price":iesadPrice["JZD2"]
            },
            3:{
                "id":3,"number":"JZD3","name":"Intermediate","des":"Age 11-14, any set performance under 5 minutes", "price":iesadPrice["JZD3"]
            },
            4:{
                "id":4,"number":"JZD4","name":"Youth","des":"Age 15-18, any set performance under 6 minutes", "price":iesadPrice["JZD4"]
            },
            5:{
                "id":5,"number":"JZD5","name":"Adult","des":"Age 18 or above, any set performance under 8 minutes", "price":iesadPrice["JZD5"]
            },
            // 6:{
            //     "id":6,"number":"DD6","name":"Adults","des":"Age 18 or above, any theatre scene, under 6 minutes", "price":iesadPrice["DD6"]
            // },
        },
        "Group":{
            1:{
                "id":1,"number":"JZG1","name":"Primary","des":"Age 7 or below, any set performance under 3 minutes", "price":iesadPrice["JZG1"]
            },
            2:{
                "id":2,"number":"JZG2","name":"Junior","des":"Age 8-10 , any set performance under 3 minutes", "price":iesadPrice["JZG2"]
            },
            3:{
                "id":3,"number":"JZG3","name":"Intermediate","des":"Age 11-14, any set performance under 5 minutes", "price":iesadPrice["JZG3"]
            },
            4:{
                "id":4,"number":"JZG4","name":"Youth","des":"Age 15-18, any set performance under 6 minutes", "price":iesadPrice["JZG4"]
            },
            5:{
                "id":5,"number":"JZG5","name":"Adult","des":"Age 18 or above, any set performance under 8 minutes", "price":iesadPrice["JZG5"]
            },
            // 6:{
            //     "id":6,"number":"DG6","name":"Adults","des":"Age 18 or above, any theatre scene, under 6 minutes", "price":iesadPrice["DG6"]
            // },
        },
    },
    "Modern":{
        "Solo":{
            1:{
                "id":1,"number":"CTS1","name":"Primary","des":"Age 7 or below, any set performance under 3 minutes", "price":iesadPrice["CTS1"]
            },
            2:{
                "id":2,"number":"CTS2","name":"Junior","des":"Age 8-10 , any set performance under 3 minutes", "price":iesadPrice["CTS2"]
            },
            3:{
                "id":3,"number":"CTS3","name":"Intermediate","des":"Age 11-14, any set performance under 5 minutes", "price":iesadPrice["CTS3"]
            },
            4:{
                "id":4,"number":"CTS4","name":"Youth","des":"Age 15-18, any set performance under 6 minutes", "price":iesadPrice["CTS4"]
            },
            5:{
                "id":5,"number":"CTS5","name":"Adult","des":"Age 18 or above, any set performance under 8 minutes", "price":iesadPrice["CTS5"]
            },
            // 6:{
            //     "id":6,"number":"DS6","name":"Adults","des":"Age 18 or above, any theatre scene, under 6 minutes", "price":iesadPrice["DS6"]
            // },
        },
        "Duo and Trio":{
            1:{
                "id":1,"number":"CTD1","name":"Primary","des":"Age 7 or below, any set performance under 3 minutes", "price":iesadPrice["CTD1"]
            },
            2:{
                "id":2,"number":"CTD2","name":"Junior","des":"Age 8-10 , any set performance under 3 minutes", "price":iesadPrice["CTD2"]
            },
            3:{
                "id":3,"number":"CTD3","name":"Intermediate","des":"Age 11-14, any set performance under 5 minutes", "price":iesadPrice["CTD3"]
            },
            4:{
                "id":4,"number":"CTD4","name":"Youth","des":"Age 15-18, any set performance under 6 minutes", "price":iesadPrice["CTD4"]
            },
            5:{
                "id":5,"number":"CTD5","name":"Adult","des":"Age 18 or above, any set performance under 8 minutes", "price":iesadPrice["CTD5"]
            },
            // 6:{
            //     "id":6,"number":"DD6","name":"Adults","des":"Age 18 or above, any theatre scene, under 6 minutes", "price":iesadPrice["DD6"]
            // },
        },
        "Group":{
            1:{
                "id":1,"number":"CTG1","name":"Primary","des":"Age 7 or below, any set performance under 3 minutes", "price":iesadPrice["CTG1"]
            },
            2:{
                "id":2,"number":"CTG2","name":"Junior","des":"Age 8-10 , any set performance under 3 minutes", "price":iesadPrice["CTG2"]
            },
            3:{
                "id":3,"number":"CTG3","name":"Intermediate","des":"Age 11-14, any set performance under 5 minutes", "price":iesadPrice["CTG3"]
            },
            4:{
                "id":4,"number":"CTG4","name":"Youth","des":"Age 15-18, any set performance under 6 minutes", "price":iesadPrice["CTG4"]
            },
            5:{
                "id":5,"number":"CTG5","name":"Adult","des":"Age 18 or above, any set performance under 8 minutes", "price":iesadPrice["CTG5"]
            },
            // 6:{
            //     "id":6,"number":"DG6","name":"Adults","des":"Age 18 or above, any theatre scene, under 6 minutes", "price":iesadPrice["DG6"]
            // },
        },
    },
    "Open Style":{
        "Solo":{
            1:{
                "id":1,"number":"OSS1","name":"Primary","des":"Age 7 or below, any set performance under 3 minutes", "price":iesadPrice["OSS1"]
            },
            2:{
                "id":2,"number":"OSS2","name":"Junior","des":"Age 8-10 , any set performance under 3 minutes", "price":iesadPrice["OSS2"]
            },
            3:{
                "id":3,"number":"OSS3","name":"Intermediate","des":"Age 11-14, any set performance under 5 minutes", "price":iesadPrice["OSS3"]
            },
            4:{
                "id":4,"number":"OSS4","name":"Youth","des":"Age 15-18, any set performance under 6 minutes", "price":iesadPrice["OSS4"]
            },
            5:{
                "id":5,"number":"OSS5","name":"Adult","des":"Age 18 or above, any set performance under 8 minutes", "price":iesadPrice["OSS5"]
            },
            // 6:{
            //     "id":6,"number":"DS6","name":"Adults","des":"Age 18 or above, any theatre scene, under 6 minutes", "price":iesadPrice["DS6"]
            // },
        },
        "Duo and Trio":{
            1:{
                "id":1,"number":"OSD1","name":"Primary","des":"Age 7 or below, any set performance under 3 minutes", "price":iesadPrice["OSD1"]
            },
            2:{
                "id":2,"number":"OSD2","name":"Junior","des":"Age 8-10 , any set performance under 3 minutes", "price":iesadPrice["OSD2"]
            },
            3:{
                "id":3,"number":"OSD3","name":"Intermediate","des":"Age 11-14, any set performance under 5 minutes", "price":iesadPrice["OSD3"]
            },
            4:{
                "id":4,"number":"OSD4","name":"Youth","des":"Age 15-18, any set performance under 6 minutes", "price":iesadPrice["OSD4"]
            },
            5:{
                "id":5,"number":"OSD5","name":"Adult","des":"Age 18 or above, any set performance under 8 minutes", "price":iesadPrice["OSD5"]
            },
            // 6:{
            //     "id":6,"number":"DD6","name":"Adults","des":"Age 18 or above, any theatre scene, under 6 minutes", "price":iesadPrice["DD6"]
            // },
        },
        "Group":{
            1:{
                "id":1,"number":"OSG1","name":"Primary","des":"Age 7 or below, any set performance under 3 minutes", "price":iesadPrice["OSG1"]
            },
            2:{
                "id":2,"number":"OSG2","name":"Junior","des":"Age 8-10 , any set performance under 3 minutes", "price":iesadPrice["OSG2"]
            },
            3:{
                "id":3,"number":"OSG3","name":"Intermediate","des":"Age 11-14, any set performance under 5 minutes", "price":iesadPrice["OSG3"]
            },
            4:{
                "id":4,"number":"OSG4","name":"Youth","des":"Age 15-18, any set performance under 6 minutes", "price":iesadPrice["OSG4"]
            },
            5:{
                "id":5,"number":"OSG5","name":"Adult","des":"Age 18 or above, any set performance under 8 minutes", "price":iesadPrice["OSG5"]
            },
            // 6:{
            //     "id":6,"number":"DG6","name":"Adults","des":"Age 18 or above, any theatre scene, under 6 minutes", "price":iesadPrice["DG6"]
            // },
        },
    },
  
   

}

export default iesadGroupCat;